module.exports = "Redirect to mobile app. If not<button class=\"btn btn-link\" (click)=\"redirectToPlayStore()\">click here</button>\n\n<!-- <img src=\"assets/images/coming-soon.webp\" alt=\"Mobile app coming soon\"> -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/devotee/mobile-app-redirect/mobile-app-redirect.component.html
// module id = ./src/app/devotee/mobile-app-redirect/mobile-app-redirect.component.html
// module chunks = main